import 'es6-promise/auto';
import config from 'config';
import App from './app';

const app = new App(config);
app.bootstrap();

if (!global.Intl) {
    require.ensure([
        'intl',
        'intl/locale-data/jsonp/en.js'
    ], function (require) {
        require('intl');
        require('intl/locale-data/jsonp/en.js');
        app.run();
    });
} else {
    app.run();
}



// WEBPACK FOOTER //
// ./src/index.js